import { useState } from 'react'
import { Alert, Button, Group, Paper, Stack, Text, Title } from '@mantine/core'
import type { RisSource } from '@racedash/shared'
import { useEvents, useSeries, createEvent } from '../data/catalog'
import EventForm, { RisSourceFields } from '../components/EventForm'
import EventTable from '../components/EventTable'

/**
 * RIS management: manual entry.
 *
 * RIS publishes no diary and no event identifiers, so there is nothing to
 * scrape. Every event here is typed in by hand, which is why this page is a
 * form rather than a job monitor.
 */
export default function VendorRis() {
  const { events, error } = useEvents('ris')
  const { series } = useSeries()
  const [adding, setAdding] = useState(false)
  const [source, setSource] = useState<RisSource>({ vendor: 'ris', feed: 'json' })

  return (
    <Stack gap="lg">
      <Group justify="space-between" align="flex-start">
        <div>
          <Title order={1} size="h2">
            RIS Timing
          </Title>
          <Text c="dimmed" size="sm">
            No diary and no event identifiers are published, so events are entered by hand.
          </Text>
        </div>
        {!adding && <Button onClick={() => setAdding(true)}>Add event</Button>}
      </Group>

      {adding && (
        <Paper withBorder p="lg">
          <Title order={2} size="h5" mb="md">
            New RIS event
          </Title>
          <EventForm
            source={source}
            sourceFields={<RisSourceFields source={source} onChange={setSource} series={series} />}
            submitLabel="Create event"
            onCancel={() => setAdding(false)}
            onSubmit={async (input) => {
              await createEvent({ ...input, source })
              setSource({ vendor: 'ris', feed: 'json' })
              setAdding(false)
            }}
          />
        </Paper>
      )}

      {error && <Alert color="red">{error}</Alert>}

      {events && events.length > 0 && (
        <Paper withBorder>
          <EventTable events={events} />
        </Paper>
      )}
      {events?.length === 0 && !adding && (
        <Paper withBorder p="xl">
          <Text c="dimmed" ta="center">
            No RIS events yet.
          </Text>
        </Paper>
      )}
    </Stack>
  )
}
